export const selectCategory = (value) => ({
	type: 'SELECT',
	payload: value,
});
